<template>
  <div class="searchBar">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="$t.information.searchBar"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Sticky, Row, Col, Search } from "vant";
Vue.use(Sticky).use(Row).use(Col).use(Search);

export default {
  name: "SearchBar",
  data() {
    return {
      searchText: "",
    };
  },
  mounted() {},
  methods: {
    onSearch() {
      if (!this.searchText) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: this.$t.information.searchBar,
        });
        return;
      }
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        name: "cargoInquiryList",
        path: "cargoInquiryList",
        query: [
          {
            name: "SearchText",
            value: this.searchText,
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.searchBar {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 95%;
        margin: auto;
        text-align: center;
        font-size: 14px;
        .van-search__action {
          width: 15%;
          color: #000;
          font-weight: 500;
        }
        .van-search__content {
          padding: 0px;
          .van-cell {
            color: #969799;
            padding: 5px 8px 5px 8px;
          }
        }
      }
    }
  }
}
</style>
